import React from 'react';

import useApi from './useApi';

const BASE_URL = '/system-item-menu';

export const useSystemMenuItems = () => {
  const { get, post, put, remove: removeItem } = useApi();

  const list = React.useCallback(async () => {
    const listedSystemMenuItems = await get(BASE_URL);
    return listedSystemMenuItems;
  }, [get]);

  const load = React.useCallback(
    async id => {
      const loadedItem = await get(`${BASE_URL}/${id}`);
      return loadedItem;
    },
    [get],
  );

  const create = React.useCallback(
    async item => {
      const createdItem = await post(BASE_URL, item);
      return createdItem;
    },
    [post],
  );

  const update = React.useCallback(
    async (id, item) => {
      const updatedItem = await put(`${BASE_URL}/${id}`, item);
      return updatedItem;
    },
    [put],
  );

  const remove = React.useCallback(
    async id => {
      const removedItem = await removeItem(`${BASE_URL}/${id}`);
      return removedItem;
    },
    [removeItem],
  );

  const getSystemMenuItemsCombo = React.useCallback(
    async (onlyParents = false) => {
      const items = await get(BASE_URL);

      if (!items) return [];

      const filteredItems = onlyParents
        ? items.filter(item => item.parent == null)
        : items;

      return filteredItems.map(({ _id, title, path, parent }) => ({
        _id,
        label: title,
        title,
        path,
        parent,
      }));
    },
    [get],
  );

  return { list, load, create, update, remove, getSystemMenuItemsCombo };
};

export default useSystemMenuItems;
